import { render, staticRenderFns } from "./CompensationFee.vue?vue&type=template&id=45ec9e44&"
import script from "./CompensationFee.vue?vue&type=script&lang=js&"
export * from "./CompensationFee.vue?vue&type=script&lang=js&"
import style0 from "./CompensationFee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports